module.exports = __webpack_public_path__ + "img/icon-juke-tablet.012e695a.svg";